import api from "./api";
import { errorHandling } from "./error.handling";

// const basePath = `${process.env.REACT_APP_API_VEHICLE_BASE_URL}/v1/automaker`;
const basePath = "https://nc8.olharfixo.com.br/Vehicles/api/v3";


async function create(payload) {
  try {
    let response = await api.post(`${basePath}/automakers`, JSON.stringify(payload));
    let treated = errorHandling.handleResponse(
      response,
      "manufacturerService.create"
    );
    if (treated) {
      return treated;
    }
    return null;
  } catch (error) {
    errorHandling.cathError(error, "manufacturerService.create");
    return null;
  }
}

async function update(payload) {
  try {
    let response = await api.put(`${basePath}/automakers/${payload.id ?? payload.automakerId}`, JSON.stringify(payload));
    let treated = errorHandling.handleResponse(
      response,
      "manufacturerService.update"
    );
    if (treated) {
      return treated;
    }
    return null;
  } catch (error) {
    errorHandling.cathError(error, "manufacturerService.update");
    return null;
  }
}

async function list() {
  
  try {
    let response = await api.get(`${basePath}/automakers`);
    let treated = errorHandling.handleResponse(
      response,
      "manufacturerService.list"
    );
    if (treated) {
      return treated;
    }
    return null;
  } catch (error) {
    errorHandling.cathError(error, "manufacturerService.list");
    return null;
  }
}

export const manufacturerService = {
  create,
  update,
  list,
};
